var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMagnifyingGlass(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 137.065,
    height: 85.373,
    viewBox: "0 0 137.065 85.373",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1284",
    "data-name": "Group 1284",
    transform: "translate(-568 -189.182)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 62.095,
    cy: 4.423,
    rx: 62.095,
    ry: 4.423,
    transform: "translate(578 262.304)",
    fill: "#ced9dd",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1112",
    "data-name": "Group 1112",
    transform: "translate(568 254.565) rotate(-73)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1129",
    "data-name": "Path 1129",
    d: "M52.828,10.565s14.422,23.855-.536,38.048-42.5,4.28-42.5,4.28-22.59-28.324.835-45.909S52.828,10.565,52.828,10.565Z",
    transform: "translate(4.337 6.991)",
    fill: "#d6e0e3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1912",
    "data-name": "Rectangle 1912",
    width: 7.197,
    height: 16.193,
    transform: "translate(30.587 61.173)",
    fill: "#8ca2af"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1913",
    "data-name": "Rectangle 1913",
    width: 14.394,
    height: 56.908,
    rx: 4,
    transform: "translate(26.988 73.768)",
    fill: "#8ca2af"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1917",
    "data-name": "Rectangle 1917",
    width: 56.327,
    height: 5.509,
    transform: "translate(11.871 15.873) rotate(45)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1130",
    "data-name": "Path 1130",
    d: "M0,0H48.989V8.856L4.182,8.416Z",
    transform: "translate(8.057 25.804) rotate(45)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    d: "M34.185,68.371A34.185,34.185,0,0,1,10.013,10.013,34.185,34.185,0,1,1,58.358,58.358,33.961,33.961,0,0,1,34.185,68.371Zm0-60.328a26.142,26.142,0,1,0,0,52.283A26.142,26.142,0,0,0,52.669,15.7,25.969,25.969,0,0,0,34.185,8.043Z",
    transform: "translate(0 0)",
    fill: "#b4bfc3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlass);
export default __webpack_public_path__ + "static/media/magnifying-glass.d9cbc116503147c96bc57ae502b1ec8e.svg";
export { ForwardRef as ReactComponent };